import { render, staticRenderFns } from "./OpenPositionImportForm.vue?vue&type=template&id=a80be3e4&scoped=true&"
import script from "./OpenPositionImportForm.vue?vue&type=script&lang=js&"
export * from "./OpenPositionImportForm.vue?vue&type=script&lang=js&"
import style0 from "./OpenPositionImportForm.vue?vue&type=style&index=0&id=a80be3e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80be3e4",
  null
  
)

export default component.exports